module.exports = __webpack_public_path__ + "static/img/image5.a95eda7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/image5.png
// module id = gE74
// module chunks = 0